import styled from 'styled-components';

import colors from 'themes/Main';

const { darkBlue, gray03, gray04 } = colors;

export const Container = styled.div`
  position: relative;
  min-height: 300px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
`;

export const Dots = styled.div`
  display: flex;
  align-items: center;
`;

export const Dot = styled.button`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${gray03};
  outline: 0;
  border: 0;
  transition: all 0.4s ease-in-out;

  &.selected {
    width: 14px;
    height: 14px;
    background-color: ${darkBlue};
  }

  + button {
    margin-left: 8px;
  }
`;

export const IndexName = styled.h3`
  font-size: 24px;
  font-weight: 700;
  line-height: 34px;
  color: ${darkBlue};
`;

export const Content = styled.div``;

export const DefaultArrow = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: 0;

  &:disabled svg path {
    fill: ${gray04};
  }

  &:hover {
    transition: opacity 300ms ease-in-out;
    opacity: 0.6;
  }
`;

export const ArrowLeft = styled(DefaultArrow)`
  left: -40px;

  svg {
    transform: rotate(180deg);
  }
`;

export const ArrowRight = styled(DefaultArrow)`
  right: -40px;
`;
